/* ==========================================================================
   ZWANZE — navigation.js
   Panneau de navigation mobile et surimpression de recherche.
   Les deux héritent de Zwanze.Panel : focus, Échap, verrouillage du scroll.
   ========================================================================== */
(function () {
  'use strict';
  const Z = window.Zwanze;
  if (!Z) return;

  /* --- Navigation mobile ---------------------------------------------------
     Un seul accordéon ouvert à la fois : la charge mentale reste basse. */
  class MobileNav extends Z.Panel {
    connectedCallback() {
      super.connectedCallback();
      document.querySelectorAll('[data-menu-open]').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
          trigger.setAttribute('aria-expanded', 'true');
        });
      });

      this.querySelectorAll('details.z-mnav__group').forEach((group) => {
        group.addEventListener('toggle', () => {
          if (!group.open) return;
          const siblings = group.parentElement.querySelectorAll(':scope > details.z-mnav__group');
          siblings.forEach((other) => { if (other !== group) other.open = false; });
        });
      });
    }
    close() {
      super.close();
      document.querySelectorAll('[data-menu-open]').forEach((t) => t.setAttribute('aria-expanded', 'false'));
    }
  }
  customElements.define('z-mobile-nav', MobileNav);

  /* --- Recherche prédictive -------------------------------------------------
     Débounce à 220 ms, requête annulable, résultats rendus par Shopify. */
  class Search extends Z.Panel {
    connectedCallback() {
      super.connectedCallback();
      this.input = this.querySelector('[data-search-input]');
      this.results = this.querySelector('[data-search-results]');
      this.initial = this.results ? this.results.innerHTML : '';
      this._timer = null;
      this._controller = null;

      document.querySelectorAll('[data-search-open]').forEach((trigger) => {
        trigger.addEventListener('click', (event) => { event.preventDefault(); this.open(); });
      });

      if (this.input) {
        this.input.addEventListener('input', () => {
          window.clearTimeout(this._timer);
          this._timer = window.setTimeout(() => this._query(), 220);
        });
      }
    }

    async _query() {
      const term = this.input.value.trim();
      if (term.length < 2) {
        this.results.innerHTML = this.initial;
        this.input.setAttribute('aria-expanded', 'false');
        return;
      }

      if (this._controller) this._controller.abort();
      this._controller = new AbortController();
      this.setAttribute('aria-busy', 'true');

      const params = new URLSearchParams({
        q: term,
        'resources[type]': 'product,collection,page,article',
        'resources[limit]': '10',
        'resources[options][unavailable_products]': 'last',
        section_id: 'predictive-search'
      });

      try {
        const response = await fetch(Z.routes.predictiveSearch + '?' + params.toString(), { signal: this._controller.signal });
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('.shopify-section') || doc.body;
        this.results.innerHTML = fresh.innerHTML;
        this.input.setAttribute('aria-expanded', 'true');
      } catch (error) {
        if (error.name !== 'AbortError') this.results.innerHTML = this.initial;
      } finally {
        this.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('z-search', Search);
})();
